// French
export const fr = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portail client',
  'app.signOut':        'Se déconnecter',

  'login.email':        'E-mail',
  'login.password':     'Mot de passe',
  'login.signIn':       'Se connecter',
  'login.signingIn':    'Connexion en cours…',
  'login.failed':       'Échec de la connexion',
  'login.newAccount':   'Nouveau sur Kardolive ?',
  'login.createAccount':'Créer un compte gratuit →',

  'nav.workspace':      'Espace de travail',
  'nav.templates':      'Modèles',
  'nav.live':           'En direct',
  'nav.rooms':          'Salles et chat',
  'nav.content':        'Contenu',
  'nav.developer':      'Développeur',
  'nav.account':        'Compte',

  'nav.overview':       'Vue d\'ensemble',
  'nav.projects':       'Projets',
  'nav.chat':           'Console de chat',
  'nav.sessions':       'Sessions',
  'nav.streams':        'Diffusions en direct',
  'nav.studio':         'Studio',
  'nav.recordings':     'Enregistrements',
  'nav.apiKeys':        'Clés API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Testeur de webhook',
  'nav.networkTest':    'Test réseau',
  'nav.embed':          'Widgets intégrés',
  'nav.sdk':            'SDK et documentation',
  'nav.docs':           'Docs développeur',
  'nav.analytics':      'Analyses',
  'nav.settings':       'Paramètres',

  'overview.welcome':       'Bon retour, {name}',
  'overview.plan':          '{tenant} · forfait {plan}',
  'overview.newStream':     'Nouvelle diffusion',
  'overview.kpi.live':           'En direct maintenant',
  'overview.kpi.live.broadcasting': 'diffusions en direct',
  'overview.kpi.live.nothing':    'rien en direct',
  'overview.kpi.total':           'Total des diffusions',
  'overview.kpi.total.sub':       'toutes périodes',
  'overview.kpi.sessions':        'Sessions · 30 jours',
  'overview.kpi.sessions.sub':    'événements de publication',
  'overview.kpi.recordings':      'Enregistrements',
  'overview.kpi.recordings.sub':  'prêts à lire',
  'overview.recentStreams':       'Diffusions récentes',
  'overview.recentSessions':      'Sessions récentes',
  'overview.viewAll':             'Tout voir →',
  'overview.empty.title':         'Aucune diffusion pour l\'instant',
  'overview.empty.body':          'Créez votre première diffusion pour commencer.',
  'overview.empty.action':        'Créer une diffusion',
  'overview.noSessions':          'Aucune session pour l\'instant',

  'status.live':        'EN DIRECT',
  'status.idle':        'INACTIF',
  'status.ended':       'TERMINÉ',
  'status.archived':    'ARCHIVÉ',

  'common.save':        'Enregistrer',
  'common.cancel':      'Annuler',
  'common.delete':      'Supprimer',
  'common.edit':        'Modifier',
  'common.create':      'Créer',
  'common.confirm':     'Confirmer',
  'common.loading':     'Chargement…',
  'common.error':       'Erreur',
  'common.retry':       'Réessayer',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Aller au contenu de la page",
  "nav.streamTemplates": "Modèles de diffusion",
  "nav.boards": "Tableaux interactifs",
  "nav.menu": "Ouvrir la navigation",
  "nav.closeMenu": "Fermer la navigation",
  "nav.scenarios": "Scénarios",
  "nav.premieres": "Premières",
  "nav.clips": "Extraits",
  "dashboard.account": "Compte",
  "dashboard.language": "Langue",
  "dashboard.appearance": "Apparence",
  "nav.allStreams": "Toutes les diffusions",
  "nav.destinations": "Destinations",
  "nav.ecommerce": "Commerce en ligne",
  "nav.products": "Produits",
  "nav.services": "Services",
  "nav.collections": "Collections",
  "nav.orders": "Commandes",
  "nav.commerceSettings": "Paramètres commerciaux",
  "nav.engagement": "Interactions",
  "theme.light": "Passer au mode clair",
  "theme.dark": "Passer au mode sombre",
  "role.owner": "Propriétaire",
  "role.admin": "Administrateur",
  "role.member": "Membre",
  "role.viewer": "Observateur",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Actifs",
  "streams.archived": "Archivés",
  "streams.monitor": "Suivi des sources",
  "streams.create": "Créer une diffusion en direct",
  "streams.list": "Liste",
  "streams.grid": "Grille",
  "streams.view": "Affichage des diffusions",
  "streams.searchLabel": "Rechercher des événements",
  "streams.searchHint": "Rechercher par nom",
  "streams.solutionFilter": "Filtrer les événements par type",
  "streams.statusFilter": "Filtrer les événements par statut",
  "streams.dateFilter": "Filtrer par date de création",
  "streams.allSolutions": "Tous les types",
  "streams.custom": "Configuration existante ou personnalisée",
  "streams.allStatuses": "Tous les statuts",
  "streams.anyTime": "Toute date de création",
  "streams.last7": "Créés ces 7 derniers jours",
  "streams.last30": "Créés ces 30 derniers jours",
  "streams.count": "{shown} événements affichés sur {total}",
  "streams.noMatch": "Aucun événement ne correspond aux filtres.",
  "streams.clearFilters": "Effacer les filtres",
  "streams.refreshFailed": "Impossible d’actualiser la liste",
  "streams.loadFailed": "Impossible de charger les diffusions",
  "streams.stale": "La dernière liste chargée est affichée. Les statuts ont peut-être changé.",
  "streams.connectionHint": "Vérifiez votre connexion et rechargez la liste.",
  "streams.retrying": "Nouvelle tentative…",
  "streams.retry": "Réessayer",
  "streams.restoreFailed": "Impossible de restaurer la diffusion",
  "streams.restoreHint": "Vérifiez votre connexion et actualisez la liste pour confirmer le statut avant de réessayer.",
  "streams.unused": "Diffusions inutilisées : {count}",
  "streams.unusedHint": "Aucune diffusion ni rediffusion. Archivez-les pour ranger votre liste ; rien ne sera supprimé.",
  "streams.reviewArchive": "Vérifier et archiver",
  "streams.loading": "Chargement des diffusions…",
  "streams.archiveEmpty": "Aucune archive. Les diffusions archivées et leurs rediffusions restent ici jusqu’à leur restauration.",
  "streams.restore": "Restaurer",
  "streams.firstTitle": "Créez votre première diffusion",
  "streams.firstBody": "Choisissez une configuration pour une vente, un cours ou un service, ou partez de zéro. Diffusez depuis un navigateur, un téléphone ou OBS.",
  "streams.blank": "Diffusion vierge",
  "streams.broadcasts": "Diffusions : {count}",
  "streams.replays": "Rediffusions : {count}",
  "streams.sessions": "Sessions : {count}",
  "streams.recordings": "Enregistrements : {count}",
  "streams.mode.BROADCAST": "Diffusion",
  "streams.mode.LOW_LATENCY": "Faible latence",
  "streams.mode.REALTIME": "Temps réel",
  "streams.key": "Clé",
  "streams.archiveTitle": "Archiver les diffusions inutilisées",
  "streams.archiveHint": "Ces événements n’ont jamais été diffusés. Vous pouvez les restaurer à tout moment depuis l’onglet Archivés.",
  "streams.archiveFailed": "Impossible d’archiver {count} diffusions ; elles sont peut-être passées en direct. Les autres ont été archivées.",
  "streams.archiving": "Archivage…",
  "streams.archiveCount": "Archiver {count}",
  "streamType.webinar": "Webinaires et lancements professionnels",
  "streamType.classroom": "Cours et soutien scolaire",
  "streamType.training": "Formation en entreprise",
  "streamType.conference": "Conférences et expositions",
  "streamType.shopping": "Vente en direct",
  "streamType.auction": "Enchères en direct",
  "streamType.consultation": "Consultations privées",
  "streamType.creator": "Créateurs et communautés en direct",
  "streamType.audio": "Salons audio et podcasts",
  "streamType.sports": "Sports et esport",
  "streamType.performance": "Concerts et spectacles",
  "streamType.community": "Culte et collecte de fonds",
  "streamType.tour": "Visites et démonstrations",
  "streamType.fitness": "Fitness et ateliers",
  "streamType.public-meeting": "Actualités et réunions publiques",
  "streamType.continuous": "Chaînes continues et caméras",
  "streams.close": "Fermer",
};
